export function transformDateToISO(date: string | Date): string {
  if (!date) {
    return '';
  }
  return typeof date === 'string' ? date : date.toISOString();
}
